import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {RefundPoliciesContent} from "@/customComponents/globalComponents/policiesContent.jsx";

// Content lives in globalComponents/policiesContent.jsx (static copy).
export {RefundPoliciesContent};

export function RefundPolicies({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={previousStep || (storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing")} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <RefundPoliciesContent/>
        </>
    );
}
export default RefundPolicies;
